
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/netzwerk",
      function () {
        return require("private-next-pages/netzwerk/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/netzwerk"])
      });
    }
  